import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep17 = (state) => state.get('step17');

const makeSelectStep17 = () =>
  createSelector(selectStep17, (step17State) => ({

    benefitAreYouClaimingFor: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'benefitAreYouClaimingFor']),
      ''
    ),

    assistance: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'assistance']),
      ''
    ),

    dateApproved: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'dateApproved']),
      ''
    ),
    
    causeOfDeath: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'causeOfDeath']),
      ''
    ),

    dateOfDeath: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'dateOfDeath']),
      ''
    ),

    stateOfDeath: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'stateOfDeath']),
      ''
    ),

    countryOfDeath: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'countryOfDeath']),
      ''
    ),
    
    wasTheMemberHospitalized: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'wasTheMemberHospitalized']),
      ''
    ),

    fromDate: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'fromDate']),
      ''
    ),

    toDate: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'toDate']),
      ''
    ),
    
    nameOfFuneralServiceProvider: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'nameOfFuneralServiceProvider']),
      ''
    ),

    costOfLocalBurial: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'costOfLocalBurial']),
      ''
    ),

    invoice: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'invoice']),
      ''
    ),

    amountClaimed: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'amountClaimed']),
      ''
    ),

    amountClaimedCurrency: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'amountClaimedCurrency']),
      ''
    ),
    
    costOfLocalBurialCurrency: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'costOfLocalBurialCurrency']),
      ''
    ),

    familyMemberProvidingInformation: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'familyMemberProvidingInformation']),
      ''
    ),

    relationshipToMember: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'relationshipToMember']),
      ''
    ),

    address: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'address']),
      ''
    ),

    cityOrTown: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'cityOrTown']),
      ''
    ),

    country: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'country']),
      ''
    ),

    postalCode: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'postalCode']),
      ''
    ),

    phoneNumber: mapWithDefault(
      step17State,
      () => step17State.getIn(['form', 'phoneNumber']),
      ''
    ),
  }));

export { makeSelectStep17 };



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step17/selectors.js